'use client';

import classnames from 'classnames';
import { Bebas_Neue } from 'next/font/google';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import { ID_CAPITOL_BLB } from '@cineamo/api/constants/cinema-ids.ts';

import { cn } from '@cineamo/ui/src/helpers/cn';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

const fontBebasNeue = Bebas_Neue({ subsets: ['latin'], weight: '400' });

const CinemaLogo = ({ className }: { className?: string }) => {
    const domainConfiguration = useDomainConfiguration();
    const cinema = domainConfiguration.cinema;

    let link: string = '/';

    // TODO: Maybe make logo link maintainable via cinema-app -> website settings?
    if (cinema?.id === ID_CAPITOL_BLB) {
        link = 'https://capitol-blb.de';
    }

    return (
        <Link
            className={cn('relative w-auto flex justify-center flex-auto my-9 lg:my-24', className)}
            href={link}>
            {/* Cinema Logo */}
            {cinema.logoWideImageUrl || cinema.logoImageUrl ? (
                <Image
                    className="w-auto h-56 lg:h-72 max-w-[85%] md:max-w-[350px] 2xl:max-w-[450px] object-contain select-none"
                    src={cinema.logoWideImageUrl || cinema.logoImageUrl}
                    alt={cinema.name}
                    width={400}
                    height={400}
                    priority={true}
                />
            ) : (
                <div
                    className={classnames(
                        'relative flex flex-none w-160 h-56 lg:h-72',
                        'my-9 lg:my-24',
                        'justify-center items-center'
                    )}>
                    <div
                        className="absolute left-0 top-0 w-full h-full border-2 rounded-16"
                        style={{
                            borderColor: domainConfiguration.style.onBackgroundColor,
                            opacity: 0.2
                        }}
                    />
                    <span
                        className={classnames(
                            fontBebasNeue.className,
                            'text-headline-24 leading-6 text-center select-none'
                        )}>
                        {cinema.name}
                    </span>
                </div>
            )}
        </Link>
    );
};

export default CinemaLogo;
